<template>
  <SyAccessoryFile
    v-bind="{ ...$props }"
    v-on="$listeners"
    :previewExtraParams='previewParamKeyName'
    :ediTable='!isPureText'
    :onlyImage="onlyImage"
    :firstImgOnly="firstImgOnly"
    :limit="maxUploadNum"
    :accept="format.join(',')"
    :maxFileSize="`${maxSize}MB`"
    :isChunk="isChunk"
    :multiple="multiple"
    :miniMode="miniMode"
    :size="size"
    :disabled="disabled"
    :checkRule="aPaasCheckInfo"
    :permission="permission"
    :on-success="handleUploadSuccess"
    :on-remove="handleUploadRemove"
    :fileList="fileList"
    :on-preview='preview'
    :filePreview="{
      ...previewApi,
      ...filePreviewProps
    }"
  ></SyAccessoryFile>
</template>

<script>
  import i18n from './i18n.js'
  // import SyUpload from '../../../../components/basis/sy-upload/upload.vue'
  import emitter from '../../../utils/emitter'

  import Store from '../../../utils/catch-state.js'
  import SyAccessoryFile from '../../../../../basis/sy-accessory/sy-accessory.vue'
  import { fileProps } from './index.js'
  import Api from './api.js'

  const pageText = window.fe.getPageText(i18n)
  
  export default {
    name: 'sy-file',
    components: {
      SyAccessoryFile
    },
    mixins: [emitter],
    inject: ['formData'],
    props: fileProps,
    model: {
      event: 'change',
      prop: 'fileList'
    },
    computed: {
      uploadTipMsg () {
        const upNum = this.fileList.length
        const remainNum = this.maxUploadNum - this.fileList.length
        return window.fe.variableReplace(this.pageText.files, {upNum: upNum, remainNum: remainNum})
      },
      previewApi () {
        if (this.data.isCustom) {
          return {
            previewApi: Api.preview
          }
        }
        return {}
      }
    },
    data () {
      this.fileList && this.fileList.map(item => {
        // item.url = this.isOpen ? this.openUrl : secretUrl
        item.uid = this.getRandomNumber()
      })
      return {
        aPaasCheckInfo: '',
        token: '',
        pageText
      }
    },
    methods: {
      getDataByKey (key) {
        if (this.data.isSubForm) {
          return this.row[key]
        }
        return this.formData[key]
      },
      // 获取附件预览需要的参数名称
      async getPreviewKeyName () {
        let previewParamKeyName = await Store.paasUpload('previewParamKeyName').getter()
        const {objectApiName, app} = this.data
        const getterPreviewData = previewParamKeyName[`${objectApiName}`]
        if (getterPreviewData) {
          this.previewParamKeyName.fileReviewBusinessCode  = getterPreviewData.fileReviewBusinessCode
          this.previewParamKeyName.bizCode  = this.data.isCustom ? `${objectApiName}$$${this.getDataByKey(getterPreviewData.bizCode)}` : this.getDataByKey(getterPreviewData.bizCode)
          this.previewParamKeyName.prewKey  = getterPreviewData.prewKey
        } else {
          const res = await Store.paasUpload('getPreviewParamName').getter({objectApiName, clientType: app})
          if (res.isOk) {
            const resCon = {
              fileReviewBusinessCode: res.content.businessCode,
              bizCode: res.content.uniqueFieldApiName,
              prewKey: res.content.fileUrlParamName
            }
            this.previewParamKeyName.fileReviewBusinessCode  = resCon.fileReviewBusinessCode
            // 新建页面 走基础附件预览不需要bizCode
            const customCode = this.data.createPageFlag ? '' : `${objectApiName}$$${this.getDataByKey(resCon.bizCode)}`
            this.previewParamKeyName.bizCode  = this.data.isCustom ? customCode : this.getDataByKey(resCon.bizCode)
            this.previewParamKeyName.prewKey  = resCon.prewKey
            previewParamKeyName[`${objectApiName}`] = resCon
            Store.paasUpload('previewParamKeyName').update(previewParamKeyName)
          }
        }
      },
      handleUploadSuccess (res, file, fileList) {
        file.filePath = res.content.filePath
        file.key = res.content.key
        this.$emit('change', fileList)
        // this.$emit('validateField')
        this.dispatch('ElFormItem', 'el.form.change', fileList)
      },
      handleUploadRemove (file, fileList) {
        this.$emit('change', fileList)
        this.dispatch('ElFormItem', 'el.form.change', fileList)
      },
      getRandomNumber () {
        return parseInt(Math.random() * 1e10)
      },
      async _getCheckInfo () {
        let fileInfos = await Store.paasUpload('fileInfos').getter()
        const {apiName, objectApiName} = this.data
        if (fileInfos[`${objectApiName}_${apiName}`]) {
          this.aPaasCheckInfo = fileInfos[`${objectApiName}_${apiName}`]
        } else {
          let res = await Store.paasUpload('getCheckInfo').getter(this.data)
          if (res.isOk) {
            this.aPaasCheckInfo = res.content
            fileInfos[`${objectApiName}_${apiName}`] = res.content
            Store.paasUpload('fileInfos').update(fileInfos)
          }
        }
      }
    },
    mounted () {
      if (!this.isPureText) {
        this._getCheckInfo()
      }
      // 如果当前附件字段是预置字段，并且业务没传入自定义的字段值，则获取paas自己存的字段值
      // 2022.07.14版本 如果是自定义附件字段，直接走下载，不走预览
      if (!this.previewParamKeyName.fileReviewBusinessCode) {
        this.getPreviewKeyName()
      }
    }
  }
</script>

<style lang="scss" scoped>
.sy-pass-file {
  .paas-file-uplaod-trigger-btn {
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #D0D0D0;
    border-radius: 16px;
    font-size: 14px;
    color: #707070;
    &:hover {
      border-color: currentColor;
    }
  }
}
.sy-pass-file-mini {
  line-height: 28px;
}
.sy-pass-file_sub {
  .paas-file-uplaod-trigger-sub-btn {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }
  .paas-file-uplaod-trigger-sub-btn-disabled {
    cursor: not-allowed;
  }
  ::v-deep .el-upload-list__item {
    font-size: 12px;
  }
}
</style>
